import { CodeFieldIncludeInactiveKey } from 'app/area/codetable/types-store';
import { CodeFieldIncludeInactiveValues } from 'app/area/import-mappings/types-store';

export const defaultIncludeInactiveCodes = CodeFieldIncludeInactiveKey.active;

export const codeFieldIncludeInactive: CodeFieldIncludeInactiveValues = {
  active: {
    enabled: false
  },
  all: {
    enabled: true
  }
};

export const referenceCodetableId = 38;
export const externalValueMaxLength = 254;
export const defaultMaxResults = 50;

export const importMappingsTranslation = {
  title: 9289,
  import_code: 9287,
  import_code_info: 9303,
  add_code: 9282,
  import_set: 9292,
  codetable: 9293,
  category: 9294,
  code: 9286,
  description: 9288,
  import_mapping: 9291,
  changes_saved: 9308,
  no_hits: 9285,
  choose_all_values: 9295,
  loading: 4501,
  search_hits: 7474,
  search_no_hits: 8309,
  no_access_to_codetable_administration: 8320,
  hide_inactive_codes_filter: 8582,
  success: 9296,
  error: 9297,
  cancel_changes: 7558,
  are_you_sure: 7460,
  undo_all: 5792,
  select_all: 8420,
  clear_all: 8421,
  go_back: 7966,
  validation_error: 8206,
  must_be_filled_out: 5949,
  manage_options: 8521,
  search_required_message: 8146,
  no_options_found: 7644,
  match_exact: 9374,
  search: 7345,
  disabled: 9302,
  done: 7338
};

export type ImportMappingsTranslation = {
  readonly [T in keyof typeof importMappingsTranslation]: string
};
